import * as ActionTypes from "constants/ActionTypes";

export default function forceChapterCover(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_FORCE_CHAPTER_COVER:
      return action.value;
    default:
      return state;
  }
}
